import React, { useState, useEffect, useRef, useContext } from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText';
import Heading from 'src/components/Heading';
import Wave from 'src/utils/Wave';
import PricingPanel from '../PricingPanel'
import RadioButton from '../RadioButton'
import GetSettings from 'src/utils/GetSettings'
import { PageContext } from 'src/utils/context'  

const PricingWithToggle = ({ blok }) => {

    const { location } = useContext(PageContext)

    const settings = GetSettings(location)

    const [active, setActive] = useState('workplace')
    const [height, setHeight] = useState(0)
    const ref = useRef(null)

    const handleResize = () => {
        setHeight(ref.current.clientHeight)
    }
  
    // Get the height of the pricing panel so we can offset the height later
    useEffect(() => {
      window.addEventListener("resize", handleResize);
      handleResize()
      return () => window.removeEventListener("resize", handleResize);
    }, [])

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="overflow-hidden">
                <div className="py-16 lg:py-28 bg-blue relative">
                    <div className="max-w-7xl mx-auto px-6 pb-16 text-center flex flex-col justify-center items-center 2xl:max-w-screen-2xl">
                        <Heading size="h2" className="text-white !mb-4 max-w-5xl">{blok.title}</Heading>
                        <p className="text-[#9890AA] lg:text-base text-sm max-w-2xl tracking-[-0.01em]">
                            <RichText>{blok.description}</RichText>
                        </p>
                        <div className="grid grid-cols-3 mt-8 gap-9" id="types">
                            <RadioButton id="workplace" active={active} setActive={setActive} handleResize={handleResize}/>
                            <RadioButton id="education" active={active} setActive={setActive} handleResize={handleResize}/>
                            <RadioButton id="sports" active={active} setActive={setActive} handleResize={handleResize}/> 
                        </div>
                    </div>
                    <div className="absolute w-full md:bottom-24 bottom-20 translate-y-full z-10" ref={ref}>
                        <PricingPanel id={'workplace'} pricing={settings.workplace} features={settings.workplace_features} additional_features={settings.workplace_additional_features} additional={settings.additional} additional_title={settings.additional_title} active={active}/>
                        <PricingPanel id={'education'} pricing={settings.education} features={settings.education_features} additional_features={settings.education_additional_features} active={active}/>
                        <PricingPanel id={'sports'} pricing={settings.sports} features={settings.sports_features} active={active}/>
                    </div>
                </div>
                <Wave size="small" className="fill-blue"/>
                <div style={{height: height}}></div>
            </div>
        </SbEditable>  
    )
}

export default PricingWithToggle
